var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{'disabled': _vm.disabled},attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[(!_vm.isLoading)?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('base-spinner',{attrs:{"is-local":true,"is-loading":_vm.isLoading,"spinner-color":_vm.spinnerColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }